import React, { useState, useEffect, useRef } from "react";
import "./StatsSection.css";

const Counter = ({ end, label }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          let start = 0;
          const duration = 2000;
          const increment = end / (duration / 16);

          const step = () => {
            start += increment;
            if (start < end) {
              setCount(Math.floor(start));
              requestAnimationFrame(step);
            } else {
              setCount(end);
            }
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [end]);

  return (
    <div className="stat-item" ref={ref}>
{/* inside your counter item */}
<div className="counter-number">
  <span className="counter-value">{count}</span>
</div>

      <div className="stat-label">{label}</div>
    </div>
  );
};

export default function StatsSection() {
  return (
    <section className="stats-section">
      <div className="stats-background"></div>
      <div className="stats-container">
        <h2 className="stats-title">Munkásságaink eredményei</h2>
        <div className="stats-grid title-md">
          <Counter end={30} label="BeszÉLJ Tag" />
          <Counter end={10} label="Cikk" />
          <Counter end={20} label="Esemény" />
          <Counter end={10} label="Szakmai előadó" />
        </div>
      </div>
    </section>
  );
}
